export enum ActionTypeEnum {
  ADD = 'add',
  REMOVE = 'remove'
}

export enum CategoryLevelEnum {
    ROOT = 'ROOT',
    INTERMEDIATE = 'INTERMEDIATE',
    LEAF = 'LEAF'
}

export enum CategoryErrorResponseEnum {
  CATEGORY_NOT_FOUND = 'Categoría o tienda no encontrada',
  CATEGORY_PERMALINK_ALREADY_USED = 'El permalink ha sido tomado',
  CATEGORY_PATCH_ACTION = 'La acción para actualizar no es reconocida',
  CATEGORY_HAS_ASSOCIATED_PRODUCTS = 'La categoría tiene productos asociados',
  CATEGORY_EXTERNAL_ID_ALREADY_USE = 'El External ID ha sido tomado',
  CATEGORY_NAME_ALREADY_USE = 'El nombre de la categoría ya está en uso',
  DEFAULT = 'Ha ocurrido un error inésperado'
}

export class CategoryIndexingDto {
  keywords: string;
  permalink: string;
  metaTitle: string;
  metaDescription: string;

  constructor() {
    this.keywords = '';
    this.permalink = '';
    this.metaTitle = '';
    this.metaDescription = '';
  }
}

export class CreateCategoryDto {
  description: string;
  externalId: string;
  parentId?: string;
  shortName: string;
  fullName: string;
  permalink?: string;
  keywords?: string;
  metaTitle?: string;
  metaDescription?: string;
  children?: ChildCategoryDto[];
  status: string;

  constructor() {
    this.description = '';
    this.externalId = '';
    this.shortName = '';
    this.fullName = '';
    this.status = '';
  }
}

export class UpdateCategoryDto {
  name?: string;
  description: string;
  externalId: string;
  parentId?: string;
  storeId?: string;
  branchId?: string;
  shortName: string;
  fullName: string;
  indexingInfo: CategoryIndexingDto;

  constructor() {
    this.name = '';
    this.description = '';
    this.externalId = '';
    this.storeId = '';
    this.shortName = '';
    this.fullName = '';
    this.indexingInfo = new CategoryIndexingDto();
  }
}

export class CategoryImageDto {
  id: string;
  url: string;
  alt: string;
  order: string;

  constructor() {
    this.id = '';
    this.url = '';
    this.alt = '';
    this.order = '';
  }
}

export class ParentCategoryDto {
  id: string;
  externalId: string;
  shortName: string;
  fullName: string;
  status?: string

  constructor() {
    this.id = '';
    this.externalId = '';
    this.shortName = '';
    this.fullName = '';
  }
}

export class ChildCategoryDto {
  id: string;
  externalId: string;
  shortName: string;
  fullName: string;
  status?: string;

  constructor() {
    this.id = '';
    this.externalId = '';
    this.shortName = '';
    this.fullName = '';
  }
}
export class CategoryAttributeDto {
  attributeName: string;
  name: string;
  searchable: boolean;


  constructor() {
    this.attributeName = '';
    this.name = '';
    this.searchable = false;
  }
}
export enum CategoryDtoStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export class CategoryV2Dto {
  id: string;
  externalId: string;
  shortName: string;
  fullName: string;
  description: string;
  keywords: string;
  permalink: string;
  metaTitle: string;
  metaDescription: string;
  parent: ParentCategoryDto;
  children: ChildCategoryDto[];
  childrenCount: number;
  level: number;
  productsCount: number;
  enabled: boolean;
  status: string;
  attributes: CategoryAttributeDto[];
  constructor() {
    this.id = '';
    this.externalId = '';
    this.shortName = '';
    this.fullName = '';
    this.description = '';
    this.keywords = '';
    this.permalink = '';
    this.metaTitle = '';
    this.metaDescription = '';
    this.parent = new ParentCategoryDto();
    this.children = [];
    this.childrenCount = 0;
    this.level = 0;
    this.productsCount = 0;
    this.enabled = false;
    this.status = 'ACTIVE';
    this.attributes = [];
  }
}

export class ListCategoryParams {
  size: number;
  page: number;
  name?: string;
  sort?: string[];
  level?: CategoryLevelEnum;

  constructor() {
    this.size = 0;
    this.page = 0;
    this.name = '';
    this.level = CategoryLevelEnum.ROOT;
  }
}

export class PageDto {
  totalItems: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;

  constructor() {
    this.totalItems = 0;
    this.pageSize = 0;
    this.currentPage = 0;
    this.totalPages = 0;
  }
}

export class PageElementsDto {
  totalElements: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;

  constructor() {
    this.totalElements = 0;
    this.pageSize = 0;
    this.currentPage = 0;
    this.totalPages = 0;
  }
}

export class ListCategoryResponse {
  page: PageElementsDto;
  items: CategoryV2Dto[];

  constructor() {
    this.page = new PageElementsDto();
    this.items = [];
  }
}

export class AddOrRemoveChildCategoryDto {
  action: ActionTypeEnum;
  childId: string;

  constructor() {
    this.action = ActionTypeEnum.ADD;
    this.childId = '';
  }
}

export class CreateCategoryResponse {
  id: string;

  constructor() {
    this.id = '';
  }
}
